import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiCheckCircle, FiVolume2, FiVolumeX } = FiIcons;

const VSL = ({ onOpenModal }) => {
  const [isMuted, setIsMuted] = useState(true);
  const [showVolumePrompt, setShowVolumePrompt] = useState(true);
  const videoRef = useRef(null);

  const toggleAudio = () => {
    if (videoRef.current) {
      const newMutedState = !videoRef.current.muted;
      videoRef.current.muted = newMutedState;
      setIsMuted(newMutedState);
      if (!newMutedState) {
        setShowVolumePrompt(false);
      }
    }
  };

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(error => {
        console.log("Autoplay blocked, waiting for interaction");
      });
    }
  }, []);

  return (
    <section id="vsl" className="relative pt-32 md:pt-40 pb-24 bg-black-pure overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-mesh-dark opacity-50 pointer-events-none"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center max-w-5xl mx-auto mb-12">
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-3xl md:text-5xl text-white mb-0 leading-[1.2] tracking-tighter"
          >
            <span className="font-black italic text-orange-500">Roadmap 6K:</span>{' '}
            <span className="font-normal">Cosa Vendere, A Che Prezzo e Come Chiudere dai Social</span>
          </motion.h1>

          <motion.p 
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-lg md:text-xl text-orange-400 font-normal uppercase tracking-[0.3em] mt-6 mb-0"
          >
            EVENTO LIVE VENERDÌ 30/01 ORE 21:00
          </motion.p>
        </div>

        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.3 }}
          className="max-w-5xl mx-auto mb-12 relative"
        >
          <div className="relative group vsl-glow rounded-[2rem] overflow-hidden border-4 border-slate-800 shadow-2xl bg-black">
            <div className="relative w-full aspect-video">
              <video 
                ref={videoRef}
                autoPlay 
                muted 
                loop 
                playsInline
                className="absolute top-0 left-0 w-full h-full object-cover"
                preload="metadata"
              >
                <source src="https://storage.googleapis.com/msgsndr/so5Q2Nu9nHUt6xGc9h1D/media/697829c7a87beb2c4c2a24f6.mp4" type="video/mp4" />
              </video>

              <AnimatePresence>
                {showVolumePrompt && (
                  <motion.div 
                    initial={{ opacity: 0, scale: 0.8, y: 20 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.8 }}
                    onClick={toggleAudio}
                    className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-30 cursor-pointer"
                  >
                    <div className="bg-orange-600 hover:bg-orange-500 text-white px-8 py-4 rounded-2xl flex items-center space-x-4 shadow-2xl border-2 border-white/20 backdrop-blur-md animate-bounce">
                      <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                        <SafeIcon icon={FiVolume2} className="text-xl" />
                      </div>
                      <span className="font-black uppercase tracking-tighter">Attiva l'Audio</span>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>

              <button 
                onClick={toggleAudio}
                className="absolute bottom-6 right-6 z-40 bg-black/60 hover:bg-orange-600 text-white w-12 h-12 rounded-full flex items-center justify-center backdrop-blur-md border border-white/10 transition-all duration-300"
              >
                <SafeIcon icon={isMuted ? FiVolumeX : FiVolume2} className="text-xl" />
              </button>

              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent pointer-events-none" />
            </div>
          </div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="text-center max-w-3xl mx-auto flex flex-col items-center"
        >
          <button 
            onClick={onOpenModal}
            className="btn-premium text-white px-12 py-5 rounded-2xl font-black text-xl flex items-center justify-center space-x-3 shadow-[0_0_40px_rgba(249,115,22,0.3)] hover:shadow-[0_0_60px_rgba(249,115,22,0.5)] transition-all mb-8"
          >
            <SafeIcon icon={FiCheckCircle} className="text-2xl" />
            <span>Iscriviti</span>
            <SafeIcon icon={FiArrowRight} />
          </button>

          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8 }}
            className="inline-flex items-center space-x-2 bg-orange-500/10 border border-orange-500/20 px-4 py-2 rounded-full"
          >
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-orange-500"></span>
            </span>
            <span className="text-orange-400 font-black text-[10px] uppercase tracking-[0.2em] italic">ISCRIZIONI APERTE</span>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default VSL;